import React, { useEffect, useMemo, useRef, useState, useCallback } from "react";
import {
  DownloadSingleReportConfig,
  manageOrderRowsData,
  orderSourceConfig,
  orderStatusConfig,
} from "../../types/types";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs, { Dayjs } from "dayjs";
import { capitalize, capitalizeFirstLetter } from "../../utils/utils";
import { ReactComponent as DownloadAllIcon } from "../../assets/image/svg/downloadAllWhite.svg";
import {
  Alert,
  Button,
  Snackbar,
  TextField,
  FormControl,
  Select,
  MenuItem,
  Tooltip,
} from "@mui/material";
import {
    getBulkOpertionData,
  getOrderListWithType,
  getOrderInvoiceDataWithType,
  getUTCDate,
} from "../../services/manageOrderService";
import { downloadAllReportsPrimarySecondary, downloadSingleReport } from "../../services/manageReportService";
import "./ManageSecondaryOrder.css";
import "../viewOrder/ViewOrder.css";
import "../manageBasket/ManageBasket.css";
import { Loader } from "../../components/loader/Loader";
import Header from "../../components/dms_common/Header";
import CustomDataGrid from "../../components/dms_common/CustomDataGrid";
import { useSearchParams } from "react-router-dom";
import {
  getDownloadSingleReportConfig,
  getOrderSource,
  manageOrderColumnsMetaData,
  sortByCreationTime,
  sortBySatus,
} from "./ManageSecondaryOrderUtils";
import {
  filterData,
  getMultipleFilterBasedData,
  searchWithStatusFilter,
  updateDatesInLocalStorage,
} from "../../components/dms_common/DmsCommonServices";
import {
  isGapMoreThanNDays,
  isStartDateIsGreaterThanEndDate,
} from "../../utils/calenderUtils";
import { getConfigData } from "../../services/configurationService";
import {
  getButtonOnClick,
  getDisabledButtonSx,
  isUserAllowedToEdit,
  safeStringify,
  truncateString
} from "../../components/dms_common/DmsUtils";
import ScreenOverlay from "../../components/dms_common/ScreenOverlay";
import {
  GenericModal,
  getGenericModalProps,
  initialGenericModalProps,
} from "../viewOrder/ViewOrderUtils";
import CustomGenericModal from "../../components/dms_common/CustomGenericModal";
import useSessionStorageDates from "../../components/dms_common/UseSessionStorageDates";
import BulkConfirm from "./BulkConfirm";
import { analytics, logLoadTrace, performance } from "../../../src/firebase";
import { logEvent } from "firebase/analytics";
import { trace, PerformanceTrace } from "firebase/performance";
import { sendSlackAlert, SlackChannel } from "../../services/slackService";
import { useNavigate } from "react-router-dom";
import { getDataFromLocalDb } from "../../services/dbService";
import SimpleBar from "simplebar-react";
import "simplebar-react/dist/simplebar.min.css";
export const CancelledInvoiceFlagging: React.FC = () => {
  return (
    <div className="CancelledInvoice_Flagging">
      <span>Invoiced</span>
    </div>
  );
};

const defaultFilterLabelMap = {
    status: "Status",
    salesRepName: "SalesRep",
    routeIdAndName: "Route",
    routeId: "Route ID",
    gstNo: "GST Type",
    locationId: "Location",
    operationType: "Operation Type"
  }

const ManageSecondaryOrder = () => {
  const ConfigDictionary = JSON.parse(
    localStorage.getItem("ConfigDictionary") ?? "{}"
  );
  const startDateAtLastNDays = ConfigDictionary?.startDateAtLastNDays ?? 0
  const newStartDate = dayjs().subtract(startDateAtLastNDays, 'day')
  const { storedStartDate, storedEndDate, storeSessionStorageDates } =
    useSessionStorageDates("manageOrders", newStartDate);
  
  const isBulkOrderConfirmAllowed =
    useRef<boolean>(false);
  const [lastRefreshed, setLastRefreshed] = useState<Dayjs>(dayjs());
  const [isProcessing, setIsProcessing] = useState(false);
  const [viewBulkConfirm, setViewBulkConfirm] = useState<boolean>(false);
  const [data, setData] = useState<manageOrderRowsData[]>([]);
  const [rows, setRows] = useState<manageOrderRowsData[]>([]);
  const [orderTrackingStagesList, setOrderTrackingStagesList] = useState<
    orderStatusConfig[]
  >([]);
  const routeIdNameMappingRef = useRef<any>({});
  const outletListRef = useRef<any>({});
  const disableViewOrderForAll = useRef<boolean>(false);
  const [startDate, setStartDate] = useState<Dayjs>(storedStartDate);
  const [endDate, setEndDate] = useState<Dayjs>(storedEndDate);
  const [loader, setLoader] = useState(true);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const allOrdersReportIdRef = useRef<string | null>(null);
  const singleOrderReportIdRef = useRef<string | null>(null);
  const orderSourcesRef = useRef<Record<string, orderSourceConfig>>({});
  const useNewOrderStatusUpdateAPI = useRef<boolean>(false);
  const [searchedValue, setSearchedValue] = useState<string>("");
  const [statusFilter, setStatusFilter] = useState<string>("ALL");
  const [downloadSingleReportConfig, setDownloadSingleReportConfig] =
    useState<DownloadSingleReportConfig | null>();
  const [genericModalProps, setGenericModalProps] = useState<GenericModal>(
    initialGenericModalProps
  );
  const [resetSearch, setResetSearch] = useState(false);
  const [filterKeys, setFilterKeys] = useState<string[]>([]); 
  const [selectedFilters, setSelectedFilters] = useState<Record<string, string[]>>(() => {
    const stored = localStorage.getItem('multipleFiltersListManageOrders');
    return stored ? JSON.parse(stored) : {};
  });
  const [multipleFiltersVisible, setMultipleFiltersVisible] =
    useState<boolean>(false);

  const [multipleFiltersList, setMultipleFiltersList] = useState<
    Record<string, Record<string, number>>
  >({});
  const [selectedFilterType, setSelectedFilterType] = useState("status");
  const [filterSearchValue, setFilterSearchValue] = useState<string>("");
  const [disableRowIds, setDisableRowIds] = useState<string[]>([]);
  const disableStockCheck = useRef<boolean>(false);
  const disableOrderEdit = useRef<boolean>(false);
  const fetchLimitedOrderData = useRef<boolean>(false);
  const orderConfirmationEnabled = useRef<boolean>(true);
  const navigate = useNavigate();
  const feature = "Sale";
  const pageID = "ManageOrder";
  const [disableOrderEditDesignationBased, setDisableOrderEditDesignationBased] = useState<boolean>(false);
  const [orderEditAllowedRoles, setOrderEditAllowedRoles] = useState<string[]>([]);
  const [searchParams, setSearchParams] = useSearchParams();
  const [appliedStatusFromQuery, setAppliedStatusFromQuery] = useState<boolean>(false);
  const showRouteIdOnly = useRef<boolean>(false);
  const orderTypeFilterForBulkSync = useRef<string[]>(["PENDING"]);
  const { multipleCategoryFilterEnabled, useKafkaBulkFlow } = ConfigDictionary;
  const [multipleFilterStatusLabelMap, setMultipleFilterStatusLabelMap] =
      useState<Record<string, string>>(defaultFilterLabelMap);

  const validDateRange = ConfigDictionary.dateRangeConfig ?? 31;

  useEffect(() => {
    const homePageRedirectParam = searchParams.get('redirect');
    if (homePageRedirectParam === 'bulkInvoice') {
      navigate('/dashboard/sale/bulkInvoice', { replace: true });
    }
  }, [searchParams, navigate]);

  // Utility function to clear status parameter from URL
  const clearStatusFromURL = () => {
    const newSearchParams = new URLSearchParams(searchParams);
    newSearchParams.delete('status');
    setSearchParams(newSearchParams);
  };

  function canWeMakeRequest() {
    if (startDate && endDate && isGapMoreThanNDays(startDate, endDate, validDateRange)) {
      setGenericModalProps(
        getGenericModalProps(
          "positive",
          `You can't select date range more than ${validDateRange} days!`
        )
      );
      return false;
    }
    if (
      startDate &&
      endDate &&
      isStartDateIsGreaterThanEndDate(startDate, endDate)
    ) {
      setGenericModalProps(
        getGenericModalProps(
          "positive",
          "To Date should be greater than from date."
        )
      );
      return false;
    }
    updateDatesInLocalStorage(startDate, endDate, feature, pageID);
    return true;
  }

  const handleApplyLog = async() => {
      logLoadTrace(handleApply,"manage_secondary_order_page_load_time");
  }

  const handleApply = async () => {
    if (canWeMakeRequest()) {
      storeSessionStorageDates(startDate, endDate);
      const start = getUTCDate(startDate, "start");
      const end = getUTCDate(endDate, "end");
      await getAllOrderData(start, end);
    }
  };

  const handleClearAllLog = async() => {
      logLoadTrace(handleClearAll,"manage_secondary_order_page_load_time");
  }

  const handleClearAll = async () => {
    const date = dayjs();
    storeSessionStorageDates(newStartDate, date);
    const start = getUTCDate(newStartDate, "start");
    const end = getUTCDate(date, "end");
    setStartDate(newStartDate);
    setEndDate(date);
    await getAllOrderData(start, end);
    setSelectedFilters({});
    setFilterSearchValue("");
    setStatusFilter("ALL");
    clearStatusFromURL();
    setAppliedStatusFromQuery(false);
  };

  useEffect(() => {
    localStorage.setItem('multipleFiltersListManageOrders', JSON.stringify(selectedFilters));
    
    if(multipleCategoryFilterEnabled) {
      // Check if filters were cleared and refresh data if needed
      const hasAnyFilters = Object.values(selectedFilters).some(arr => arr.length > 0);
      
      if ( !hasAnyFilters && statusFilter !== "ALL") {
        setStatusFilter("ALL");
      }
    }
  }, [selectedFilters, statusFilter]);
  

  const getAllOrderData = async (startDate: string, endDate: string) => {
    const routeIdNameMapping = routeIdNameMappingRef.current;
    const outletListResult = outletListRef.current;

    setLastRefreshed(dayjs());
    setResetSearch(true);
    setTimeout(() => setResetSearch(false), 0);
    setRows([]);
    setData([]);
    try {
      let pageNumber = 0;
      let hasMoreData = true;
      setLoader(true);
      let responseArray: manageOrderRowsData[] = [];
      while (hasMoreData){
        const response = ConfigDictionary?.mergeManageOrderInvoice ?  await getOrderInvoiceDataWithType(
          startDate,
          endDate,
          "secondary,VisitOrder,subd",
          "",
          true,
          true,
          pageNumber,
          !(fetchLimitedOrderData.current)
        ) : await getOrderListWithType(
          startDate,
          endDate,
          "secondary,VisitOrder,subd",
          "",
          true,
          true,
          pageNumber,
          !(fetchLimitedOrderData.current)
        ) 
        

        if (response?.data?.features?.length > 0) {
          // hasMoreData = response?.data?.features?.length < 1000 ? false : true;
          response?.data?.features?.forEach((item: any, index: any) => {
            const {
              id,
              outletName,
              outletCode,
              creationTime,
              totalCaseQuantity,
              totalPieceQuantity,
              totalOtherUnitQuantity,
              netAmount,
              status,
              orderNumber,
              salesRepName,
              salesRepId,
              invoiceNumber,
              eInvoice,
              orderDetails,
            } = item || {};

            const operationType = item?.operationType ?? "";
            const extraParams = status === "INVOICED" ? `?type=invoice` : ``;
            const orderSource = getOrderSource(item);
            const routeId = item?.beat ?? item?.extendedAttributes?.beat ?? ""
            const routeName = (ConfigDictionary.fetchPricingBySalesrep) ? (routeIdNameMapping?.[routeId]?.filter1 ?? "-") : (item?.beatName ?? "-");
            // const routeIdAndName = routeId ? (routeIdNameMapping?.[routeId]?.filter1 ? `${routeId}-${routeIdNameMapping[routeId].filter1}` : routeId) : "";

            const locationId = typeof routeId === "string" && routeId.length >= 2
              ? routeId.slice(0, 2)
              : routeId ?? "";
            const allRouteNames = Object.values(routeIdNameMapping).map((route: any) => route?.filter1).filter(Boolean);
            
            const isDuplicateRouteName = allRouteNames.filter((name: string) => name === routeName).length > 1;
            
            // Show only route name by default, but if same name exists then show name-code format
            const routeIdAndName = showRouteIdOnly.current ?
              (routeId ? routeId : "") 
              :
              routeId && routeName !== "-" 
              ? (isDuplicateRouteName 
                  ? `${routeName}-${routeId}`
                  : routeName)
              : "";

            const gstNo = outletListResult?.[outletCode]?.[0]?.gstNo ? "GST Outlet" : "Non-GST Outlet"
            const outletHasGstin = outletListResult?.[outletCode]?.[0]?.gstNo ? true : false

            const isCancelledInvoice: boolean =
              status?.toLowerCase() == "rejected" && invoiceNumber ? true : false;
            const downloadId = id;

            responseArray.push({
              id,
              outletName,
              operationType,
              outletCode,
              creationTime,
              totalCaseQuantity,
              totalPieceQuantity,
              totalOtherUnitQuantity,
              netAmount: netAmount,
              status: status
                ?.toLowerCase()
                ?.replace(/(?:^|\s|&)\S/g, (match: any) => match?.toUpperCase()) ?? "",
              orderNumber,
              source: orderSource,
              extraParams,
              salesRepName,
              salesRepId,
              checkOrderStatus: true,
              eInvoiced: eInvoice === "true",
              cancelledInvoice: isCancelledInvoice,
              orderDetails,
              showEyeIcon: Boolean(disableOrderEdit?.current),
              invoiceNumber,
              refNo : (invoiceNumber ? ("Invoice: " + invoiceNumber) : ("Order: " + orderNumber) ),
              routeId,
              routeName,
              routeIdAndName,
              downloadId,
              gstNo,
              outletHasGstin,
              locationId,
            });
          });

          logEvent(analytics, "secondary_order_list_viewed", {
            "distributor_id": JSON.parse(localStorage.authContext).user.loginId,
            "total_orders_displayed": responseArray?.length,
          });
        } else {
          hasMoreData = false
          // setRows([]);
          // setData([]);
        }
        pageNumber += 1;
      }
      if(useKafkaBulkFlow && useKafkaBulkFlow) {
        handleUpdateBulkStatus(responseArray);
      }
      if(disableViewOrderForAll.current) {
        setDisableRowIds([...disableRowIds, ...responseArray?.flatMap(rs => rs?.id)])
      }
      sortByCreationTime(responseArray);
      sortBySatus(responseArray);
      setRows(responseArray);
      setData(responseArray);
      // Preserve status if applied via URL param; otherwise default to ALL
      setStatusFilter((prev) => prev ?? "ALL");
      setSearchedValue("");

    } catch (error) {
      await sendSlackAlert(
       SlackChannel.DMS_SECONDARY_UI_NOTIFICATION,
        "Order Data Fetch Error - ManageSecondaryOrder.tsx",
        `Failed to fetch order data. Error: ${(error as Error).message}`,
        safeStringify({
          userId: JSON.parse(localStorage.authContext).user.loginId,
          startDate,
          endDate,
          timestamp: new Date().toISOString(),
          error,
        })
      );
      setRows([]);
      setGenericModalProps(
        getGenericModalProps("error", "Something went wrong")
      );
    } finally {
      setLoader(false);
    }
  };

  const handleUpdateBulkStatus = async (orderData: manageOrderRowsData[]) => {
    const { newOrderStatusMap, orderInvoiceNumberMap } = await getBulkOpertionData(undefined);
    let inProgressOrders: string[] = newOrderStatusMap?.inProgress ?? [];
    let idsToDisable: string[] = [];

    for (const ro of orderData) {
      let roId = ro?.id;
      let roOrderNumber = ro?.orderNumber;
      if (roId && inProgressOrders.includes(roOrderNumber)) {
        idsToDisable.push(roId);
      }
    }

    setDisableRowIds([...disableRowIds, ...idsToDisable]);
  }


  const handleSearchValueChange = (newValue: string) => {
    setSearchedValue(newValue);
  };

  const handleStatusFilterChange = (newFilter: string) => {
    setStatusFilter(newFilter);
    
    // Only clear URL parameters if we're changing from a URL-applied filter AND going to ALL
    if (appliedStatusFromQuery && newFilter === "ALL") {
      clearStatusFromURL();
      setAppliedStatusFromQuery(false);
    }

    logEvent(analytics, "secondary_order_filter_applied", {
      "distributor_id": JSON.parse(localStorage.authContext).user.loginId,
      "filter_type": newFilter,
    });
  };

  const handleFilterSearchValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFilterSearchValue(e.target.value);
    logEvent(analytics, "secondary_order_filter_applied", {
      "distributor_id": JSON.parse(localStorage.authContext).user.loginId,
      "filter_type": e.target.value,
    });
    e.stopPropagation();
  };


  const filteredData = useMemo(() => {
    const labelToIdMap = new Map<string, string>();

    orderTrackingStagesList.forEach((stage) => {
      if (stage?.dmsLabel && stage?.id) {
        labelToIdMap.set(stage.dmsLabel.toUpperCase(), stage.id);
      }
    });

    // If user has manually changed filters and we have selectedFilters, use those
    // Otherwise fall back to statusFilter for backward compatibility
    const hasUserSelectedFilters = Object.keys(selectedFilters).length > 0 &&
      Object.values(selectedFilters).some(arr => arr.length > 0);

    let finalFilteredData = data;

    if (multipleCategoryFilterEnabled && hasUserSelectedFilters) {
      // Use multiple filter approach when user has selected specific filters
      const updatedSelectedFilters = { ...selectedFilters };

      // Convert status labels to IDs if needed
      if (filterKeys.includes("status") && selectedFilters["status"]) {
        let statuses: string[] = [];
        selectedFilters["status"].forEach((status) => {
          statuses = [...statuses, ...labelToIdMap.get(status.toUpperCase())?.split(',').map((label) => label.trim()) ?? []];
        });
        updatedSelectedFilters["status"] = statuses;
      }

      finalFilteredData = getMultipleFilterBasedData(data, updatedSelectedFilters, filterKeys);
    } else {
      // Fall back to original statusFilter approach for backward compatibility
      finalFilteredData = data;
    }

    // Apply search filtering
    const searchFilteredData = filterData(
      finalFilteredData,
      searchedValue?.toLowerCase(),
      searchWithStatusFilter,
      hasUserSelectedFilters ? "ALL" : statusFilter
    );

    let filteredResults = searchFilteredData;

    if (multipleCategoryFilterEnabled && hasUserSelectedFilters) {
      // Find intersection for multiple filters
      filteredResults = finalFilteredData.filter((item: any) =>
        new Set(searchFilteredData).has(item)
      );
    }

    if (searchedValue?.length !== 0) {
      logEvent(analytics, "search_secondary_order", {
        "distributor_id": JSON.parse(localStorage.authContext).user.loginId,
        "search_query": searchedValue,
        "result_count": filteredResults?.length ?? 0,
      });
    }

    if (hasUserSelectedFilters) {
      logEvent(analytics, "search_secondary_order", {
        "distributor_id": JSON.parse(localStorage.authContext).user.loginId,
        "filter_type": "multiple_filters_applied",
      });
    } else if (statusFilter !== "ALL") {
      logEvent(analytics, "search_secondary_order", {
        "distributor_id": JSON.parse(localStorage.authContext).user.loginId,
        "filter_type": statusFilter,
      });
    }

    return filteredResults;
  }, [
    searchedValue,
    statusFilter,
    data,
    selectedFilters,
    filterKeys,
  ]);

  useEffect(() => {
    setRows(filteredData);
  }, [filteredData]);

  useEffect(() => {
    if (appliedStatusFromQuery) return;
    // Wait until stages are available
    if (!orderTrackingStagesList || orderTrackingStagesList.length === 0) return;

    const statusParam = searchParams.get("status");

    if (statusParam) {
      const normalized = statusParam.trim().toUpperCase();
      // Try to match with stage id first, then by dms label
      const matchedById = orderTrackingStagesList.find((s) => s.id?.toUpperCase() === normalized);
      const matched = matchedById;

      if (matched && matched.id) {
        setStatusFilter(matched.id);
        // Clear previous filters and set Status multi-filter using label when available
        const statusLabel = (matched.id).toUpperCase();
        setSelectedFilters({ status: [statusLabel] });
        setAppliedStatusFromQuery(true);
        return;
      }
    }
  }, [orderTrackingStagesList, searchParams, appliedStatusFromQuery]);



  const handleSnackbarClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };

  const getInitalTableData = async () => {
    const start = getUTCDate(startDate, "start");
    const end = getUTCDate(endDate, "end");
    await getAllOrderData(start, end);
  };

  const handleDownloadAll = async () => {
    if (
      startDate &&
      endDate &&
      isStartDateIsGreaterThanEndDate(startDate, endDate)
    ) {
      setGenericModalProps(
        getGenericModalProps(
          "positive",
          "To Date should be greater than from date."
        )
      );
      return;
    }
    if (isProcessing) return;
    try{
    setIsProcessing(true);
    logEvent(analytics, "manage_order_download_all_reports_click", {
      "start_date": startDate,
      "end_date": endDate,
      "login_id": JSON.parse(localStorage.authContext).user.loginId
    });

    const startTime = window.performance.now();

    await downloadAllReportsPrimarySecondary(
      allOrdersReportIdRef.current,
      setSnackbarOpen,
      startDate,
      endDate,
      "type",
      // "VisitOrder",
      undefined,
      setIsProcessing
    );

    const endTime = window.performance.now();
    logEvent(analytics, "secondary_order_report_downloaded", {
      "distributor_id": JSON.parse(localStorage.authContext).user.loginId,
      "report_type": "VisitOrder",
      "download_format": "xlsx",
      "download_time": (endTime - startTime),
    });
  }catch(error) {
    await sendSlackAlert(
      SlackChannel.DMS_SECONDARY_UI_NOTIFICATION,
      "Report Download Failure - ManageSecondaryOrder.tsx",
      `Failed to download all reports. Error: ${(error as Error).message}`,
      safeStringify({
        userId: JSON.parse(localStorage.authContext).user.loginId,
        startDate: startDate.format("YYYY-MM-DD"),
        endDate: endDate.format("YYYY-MM-DD"),
        timestamp: new Date().toISOString(),
        error,
      })
    );
  }
  finally{
    setIsProcessing(false);
  }
  };

  const handleCustomDownload = async (downloadId: string, setSnackbarOpen: React.Dispatch<React.SetStateAction<boolean>>) => {
    if (isProcessing) return;
    
    try {
      setIsProcessing(true);
      
      const rowData = data.find(row => row?.id === downloadId);
      
      if (!rowData) {
        return;
      }
      
      let reportName = downloadSingleReportConfig?.reportId ?? "OrdersReport";
      if (ConfigDictionary?.mergeManageOrderInvoice && rowData?.invoiceNumber) {
        const salesReportIdConfig = await getConfigData(
          "dms_configuration",
          "salesReportId"
        );
        reportName = salesReportIdConfig[0]?.configValue ?? "";        
      }
      
      const customConfig = {
        reportId: reportName,
        filters: (downloadSingleReportConfig?.filters ?? []).map((filter) => {
          const filterValueKey = filter?.key ?? "";
          const filterValue = rowData?.[filterValueKey] ?? "";
          return { key: filter?.key, value: filterValue };
        }),
      };
      
      await downloadSingleReport(
        customConfig,
        setSnackbarOpen,
        setIsProcessing,
        undefined,
        false,
        undefined
      );
      
    } catch (error) {
      console.error("Download error:", error);
    } finally {
      setIsProcessing(false);
    }
  };


  const fetchRequiredConfigs = async () => {
    try {
      const dbResult = await getDataFromLocalDb("RouteNameIdMapping");
      routeIdNameMappingRef.current = dbResult?.data?.[0]?.data ?? {};

      const outletListResult = await getDataFromLocalDb("OutletList");
      const groupedByOutletCode = (outletListResult?.data ?? []).reduce(
        (acc: Record<string, any[]>, item: any) => {
          const code = item?.outletCode;
          if (!acc[code]) {
            acc[code] = [];
          }
          acc[code].push(item);
          return acc;
        },
        {}
      );
      outletListRef.current = groupedByOutletCode;

      const orderTrackingStages = await getConfigData(
        "order_configuration",
        "orderTrackingStages"
      );
      const orderReportIdConfig = await getConfigData(
        "dms_configuration",
        "orderReportId"
      );
      const orderSourcesConfig = await getConfigData(
        "dms_configuration",
        "orderSources"
      );
      const fetchLimitedOrderDataConfig = await getConfigData(
        "dms_configuration",
        "fetchLimitedOrderData"
      );
      const orderBulkConfirmationConfig = await getConfigData(
        "order_configuration",
        "bulkOrderConfirmation"
      );
      const orderTypeFilterForBulkSyncConfig = await getConfigData(
        "dms_configuration",
        "orderTypeFilterForBulkSync"
      );
      orderTypeFilterForBulkSync.current = orderTypeFilterForBulkSyncConfig[0]?.configValue ?? ["PENDING"];
      const filterKeysConfig = await getConfigData("dms_configuration","multiFilterKeysManageOrders");
      setFilterKeys(filterKeysConfig[0]?.configValue ?? ["status", "salesRepName"]);
      const res12 = await getConfigData("dms_configuration", "disableOrderEditDesignationBased");
      setDisableOrderEditDesignationBased(res12[0]?.configValue?.enable ?? false);
      setOrderEditAllowedRoles(res12[0]?.configValue?.rolesAllowedForOrderEdit ?? [])
      const res9 = await getConfigData("dms_configuration", "allSecondaryOrdersReportId");
      const res8 = await getConfigData("dms_configuration", "useNewOrderStatusUpdateAPI");
      const res4 = await getConfigData("dms_configuration", "disableOrderEdit");
      const res3 = await getConfigData("dms_configuration", "disableStockCheck");
      const res10 = await getConfigData("order_configuration", "orderConfirmationEnabled")
      const res11 = await getConfigData("order_configuration", "disableViewOrderForAll")
      const res13 = await getConfigData(
        "dms_configuration",
        "multipleFilterStatusLabelMap"
      );
      setMultipleFilterStatusLabelMap(
        res13[0]?.configValue ?? defaultFilterLabelMap
      );
      const orderReportId = orderReportIdConfig[0]?.configValue ?? "";
      allOrdersReportIdRef.current = res9[0] ? res9[0]?.configValue : orderReportId;
      disableViewOrderForAll.current = res11[0]?.configValue ?? disableViewOrderForAll.current;
      fetchLimitedOrderData.current = fetchLimitedOrderDataConfig?.[0]?.configValue ?? false;
      singleOrderReportIdRef.current = orderReportId;
      const orderSourcesMapping: Record<string, orderSourceConfig> = {};
      orderSourcesConfig[0]?.configValue?.forEach(
        (sourceObj: orderSourceConfig) => {
          orderSourcesMapping[sourceObj.id] = sourceObj;
        }
      );
      orderSourcesRef.current = orderSourcesMapping;
      disableStockCheck.current = res3[0]?.configValue?.toLowerCase?.() === "true" ? true : false;
      useNewOrderStatusUpdateAPI.current = res8[0]?.configValue ?? false;
      isBulkOrderConfirmAllowed.current = orderBulkConfirmationConfig[0]?.configValue === "true" || orderBulkConfirmationConfig[0]?.configValue === true;
      orderConfirmationEnabled.current = res10[0]?.configValue ?? true;
      setOrderTrackingStagesList(orderTrackingStages[0]?.configValue ?? []);
      setDownloadSingleReportConfig(
        getDownloadSingleReportConfig(orderReportId)
      );
      disableOrderEdit.current = res4[0]?.configValue ?? false;
    } catch (e) {
      await sendSlackAlert(
        SlackChannel.DMS_SECONDARY_UI_NOTIFICATION,
        "Configuration Fetch Error - ManageSecondaryOrder.tsx",
        `Failed to fetch required configurations. Error: ${(e as Error).message}`,
        safeStringify({
          userId: JSON.parse(localStorage.authContext).user.loginId,
          timestamp: new Date().toISOString(),
          e,
        })
      );
      console.error("Error while fetching configs", e);
    }
  };

  const initInitialize = async () => {
    await fetchRequiredConfigs();
    await getInitalTableData();
  }

  const init = async () => {
    setLoader(true);

    await initInitialize();
  };

  useEffect(() => {
    if (!viewBulkConfirm) {
      logLoadTrace(init,"manage_secondary_order_page_load_time");
    }
  }, [viewBulkConfirm, startDate, endDate]);

  useEffect(() => {
    const interval = setInterval(() => {
      getInitalTableData();
    }, 5 * 60 * 1000);
    return () => clearInterval(interval);
  }, [startDate, endDate]);

  useEffect(() => {
    const counts: Record<string, Record<string, number>> = {};
    filterKeys.forEach((key) => {
      counts[key] = {};
    });

    if (filterKeys.includes("status")) {
      const labelToIdMap = new Map<string, string>();
      let allDmsLabel: string | undefined;
      orderTrackingStagesList.forEach((stage) => {
        if (stage?.dmsLabel && stage?.id) {
          labelToIdMap.set(stage.dmsLabel.toUpperCase(), stage.id);
          if (stage.id === "ALL") {
            allDmsLabel = stage.dmsLabel.toUpperCase();
          }
        }
      });

      orderTrackingStagesList.forEach((stage: any) => {
        if (stage?.dmsLabel && stage.dmsLabel.toUpperCase() !== allDmsLabel) {
          counts["status"][stage.dmsLabel.toUpperCase()] = 0;
        }
      });

      data.forEach((row: any) => {
        const rowStatus = row?.status?.toUpperCase();
        Object.keys(counts["status"]).forEach((key) => {
          const labels = labelToIdMap.get(key)?.split(',').map((label) => label.trim()) ?? [];
          if (labels.includes(rowStatus)) {
            counts["status"][key] += 1;
          }
        });
      });
    }

    filterKeys.filter((key) => key !== "status").forEach((key) => {
      data.forEach((row: any) => {
        const value = row[key];
        if ( typeof value === "string" && value) {
          counts[key][value.toLowerCase()] = (counts[key][value.toLowerCase()] || 0) + 1;
        }
      });
    });

    setMultipleFiltersList(counts);
  }, [orderTrackingStagesList, data, filterKeys]);

  const handleBulkNav = () => {
    if (orderConfirmationEnabled.current) {
      setViewBulkConfirm(!viewBulkConfirm)
    } else {
      navigate("/dashboard/sale/bulkInvoice");
    }
  }


  const handleRedirect = async(url: string, rowData: any) => {
   
    let targetPath: string;
  
    if (ConfigDictionary?.mergeManageOrderInvoice && rowData?.invoiceNumber) {
      targetPath = `/dashboard/sale/manageInvoices/viewInvoice/${rowData.orderNumber}`;
    } else {
      targetPath = `/dashboard/sale/manageOrders/viewOrder/${rowData.id}`;
    }
  
    navigate(targetPath, { state: rowData });
  };

  const handleSelectedFilterChange = (key: string, value: string) => {
    setSelectedFilters((prev) => {
      const current = prev[key] || [];
      const newFilters = {
        ...prev,
        [key]: current.includes(value)
          ? current.filter((v) => v !== value)
          : [...current, value],
      };
      
      // Check if this was the last filter being deselected
      const hasAnyFilters = Object.values(newFilters).some(arr => arr.length > 0);
      
      if (!hasAnyFilters) {
        // Use setTimeout to avoid state update conflicts
        setTimeout(() => {
          clearStatusFromURL();
          setAppliedStatusFromQuery(false);
          setStatusFilter("ALL");
        }, 0);
      }
      
      return newFilters;
    });
  };

  const handleFilterTypeChange = (type: string) => {
    setSelectedFilterType(type);
    setFilterSearchValue("");
  };

  useEffect(() => {
  const handleKeyDown = (event: KeyboardEvent) => {
    // Check for Ctrl+A or Command+A
    if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === 'a') {
      event.preventDefault(); // Prevent default browser behavior (e.g., select all)
      // Only trigger if bulk order confirmation is allowed and no modal is open
      if (!document.querySelector('[role="dialog"]')) {
        logLoadTrace(
          () =>  !orderConfirmationEnabled.current ?  navigate("/dashboard/sale/bulkInvoice") : setViewBulkConfirm(true),
          "manage_secondary_order_bulk_confirm_toggle_time"
        );
      }
    }
  };

  window.addEventListener("keydown", handleKeyDown);
  return () => {
    window.removeEventListener("keydown", handleKeyDown);
  };
}, [viewBulkConfirm]);

  return viewBulkConfirm && isBulkOrderConfirmAllowed ? (
    <BulkConfirm
      pending_data={
        Array.isArray(rows)
          ? rows.filter((row) => row.status.toLowerCase() === "pending")
          : []
      }
      startDateV={startDate}
      endDateV={endDate}
      handleToggle={() => setViewBulkConfirm(!viewBulkConfirm)}
      disableStockCheck = {disableStockCheck.current}
      useNewUpdateStatusAPI = {useNewOrderStatusUpdateAPI.current}
      multipleCategoryFilterEnabled={multipleCategoryFilterEnabled}
    />
  ) : (
    <div className="manage_order_parent">
      <ScreenOverlay apply={loader} />

      <CustomGenericModal
        type={genericModalProps?.type}
        message={genericModalProps?.message}
        leftButtonText={genericModalProps?.leftButtonText}
        modalOpen={genericModalProps?.open}
        onClose={() => setGenericModalProps(initialGenericModalProps)}
      />

      <Snackbar
        open={snackbarOpen}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        autoHideDuration={5000}
        onClose={handleSnackbarClose}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity="info"
          variant="filled"
          sx={{ width: "100%" }}
        >
          Your report will be downloaded shortly.
        </Alert>
      </Snackbar>

      <Header
        title={"Manage Orders"}
        searchFunction={loader ? () => {} : handleSearchValueChange}
        onRefresh={initInitialize}
        resetSearch={resetSearch}
        lastRefreshed={lastRefreshed}
      />

      <div className="dms_toolbar">
        <div className="manage_order_support_utility_dates_manageOrder">
          <LocalizationProvider
            dateAdapter={AdapterDayjs}
            className="manage_order_dateEnter"
          >
            <DatePicker
              label="From Date"
              inputFormat="DD-MM-YYYY"
              value={startDate}
              maxDate={dayjs()}
              onChange={(value) => {
                if (value) {
                  setStartDate(value);
                }
              }}
              renderInput={(props) => (
                <TextField
                  {...props}
                  inputProps={{
                    ...props.inputProps,
                    readOnly: true,
                  }}
                  disabled
                  size="small"
                />
              )}
            />
          </LocalizationProvider>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="To Date"
              inputFormat="DD-MM-YYYY"
              value={endDate}
              maxDate={dayjs()}
              onChange={(value) => {
                if (value) {
                  setEndDate(value);
                }
              }}
              renderInput={(props) => (
                <TextField
                  {...props}
                  inputProps={{
                    ...props.inputProps,
                    readOnly: true,
                  }}
                  disabled
                  size="small"
                />
              )}
            />
          </LocalizationProvider>
          <Button
            variant="contained"
            sx={{
              textTransform: "none",
              backgroundColor: "#237C9D",
              boxShadow: "none",
              "&:hover": {
                boxShadow: "none",
                backgroundColor: "#237C9D",
              },
            }}
            onClick={handleApplyLog}
          >
            Apply
          </Button>
          <Button
            variant="outlined"
            sx={{
              textTransform: "none",
              backgroundColor: "#f0fbff",
              boxShadow: "none",
              "&:hover": {
                boxShadow: "none",
                backgroundColor: "#f0fbff",
              },
            }}
            onClick={handleClearAllLog}
          >
            Reset
          </Button>
          <Button
            variant="contained"
            sx={{
              ...getDisabledButtonSx(snackbarOpen),
              textTransform: "none",
              minWidth: "160px",
              backgroundColor: "var(--dashboard-theme-color)",
              boxShadow: "none",
              "&:hover": {
                boxShadow: "none",
                background: "var(--dashboard-theme-color)",
              },
            }}
            onClick={getButtonOnClick(handleDownloadAll, snackbarOpen)}
            disableRipple={snackbarOpen}
          >
            <DownloadAllIcon style={{ marginRight: "6px" }} />
            Download All
          </Button>
        </div>
        {multipleCategoryFilterEnabled ? (
          <FormControl className="manage_secondary_orders_filter">
            <span style={{ fontSize: "14px", color: "#6E6969" }}>Filter:</span>
            <Select
              variant="outlined"
              labelId="dropdown_label"
              open={multipleFiltersVisible}
              value="Filter Orders"
              onOpen={() => {
                setMultipleFiltersVisible(true);
                setFilterSearchValue("");
              }}
              onClose={() => setMultipleFiltersVisible(false)}
              renderValue={() => (
                <span style={{ color: "#909090", fontSize: "14px" }}>
                  Filter Orders
                </span>
              )}
              sx={{
                border: Object.values(selectedFilters)?.some(arr => arr?.length > 0)
                  ? "1px solid var(--dashboard-theme-color)"
                  : "1px solid #ccc",
                boxSizing: "border-box",
                height: "37px",
                minWidth: "190px",
                marginLeft: "10px",
                "& .MuiSelect-select": {
                  height: "32px",
                  padding: "6px 12px",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  color: "#909090",
                  outline: "none",
                  border: "none",
                },
                "& .MuiOutlinedInput-root.Mui-focused": {
                  outline: "none",
                  boxShadow: "none",
                },

                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#DEDEDE",
                  borderWidth: "1px",
                },

                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#DEDEDE",
                },

                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#DEDEDE",
                  borderWidth: "1px",
                },
              }}
              MenuProps={{
                anchorOrigin: {
                  vertical: "bottom",
                  horizontal: "right",
                },
                transformOrigin: {
                  vertical: "top",
                  horizontal: "right",
                },
                PaperProps: {
                  sx: {
                    boxShadow: "none",
                    marginTop: "4px",
                    border: "1px solid #DEDEDE",
                  },
                },
                MenuListProps: {
                  sx: {
                    paddingTop: "8px",
                    paddingBottom: "0",
                  },
                },
              }}
            >
              <MenuItem
                key={`filter-${selectedFilterType}-${JSON.stringify(selectedFilters)}`}
                disableRipple
                style={{
                  padding: 0,
                  backgroundColor: "transparent",
                  outline: "none",
                }}
                onClick={(e) => {
                  e.stopPropagation();
                }}
              >
                <div className="MSO_filter-dropdown-container"
                  onClick={(e) => e.stopPropagation()}
                >
                  <div className="MSO_filter-header">
                    <span className="MSO_filter-name">All Filters</span>
                    <span
                      className={`MSO_filter-clear-all ${
                        (Object.values(selectedFilters).some((arr) => arr.length > 0) || 
                          filterSearchValue) &&
                        `MSO_filter-clear-all_active`
                      }`}
                      onClick={(e) => {
                        e.stopPropagation();
                        setSelectedFilters({});
                        setFilterSearchValue("");
                        // Clear URL parameters when clearing all filters
                        clearStatusFromURL();
                        setAppliedStatusFromQuery(false);
                      }}
                    >
                      Clear All
                    </span>
                  </div>
                  <div className="MSO_filter_searchBar_container">
                    <div></div>
                    <input
                      className="MSO_fiter_searchBar"
                      placeholder="Search..."
                      value={filterSearchValue}
                      onClick={(e) => e.stopPropagation()}
                      onChange={handleFilterSearchValueChange}
                      autoFocus
                      onBlur={(e) => e.target.focus()}
                    />
                  </div>

                  <div className="MSO_filter-options">
                    <div className="MSO_filter-options-left">
                      {filterKeys.map((key) => (
                        <div
                          key={key}
                          className={`${selectedFilterType === key && `MSO_filterSelected`}`}
                          onClick={(e) => {
                            handleFilterTypeChange(key);
                            e.stopPropagation();
                          }}
                        >
                            {multipleFilterStatusLabelMap?.[key] ?? key} (
                            {(selectedFilters[key] || []).length})
                        </div>
                      ))}
                    </div>
                    <div className="MSO_filter-options-right">
                      {filterKeys.map(
                        (key) =>
                          selectedFilterType === key && (
                            <SimpleBar className="MSO_filter-option-secondary" key={key}>
                              {Object.keys(multipleFiltersList[key] ?? {})
                                .filter((value) =>
                                  filterSearchValue && typeof value === "string"
                                    ? value.toLowerCase().includes(filterSearchValue.toLowerCase())
                                    : true
                                )
                                .map((value) => (
                                  <label
                                    key={value}
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "8px",
                                      color: "#444444",
                                      fontSize: "13px",
                                    }}
                                    onClick={(e) => e.stopPropagation()}
                                  >
                                    <input
                                      type="checkbox"
                                      checked={(selectedFilters[key] || []).includes(value)}
                                      onChange={() => handleSelectedFilterChange(key, value)}
                                      style={{ borderColor: "#CBCBCB" }}
                                    />
                                    {key === "source" ? (
                                       `${value.toUpperCase()} (${multipleFiltersList[key]?.[value] || 0})`
                                     ) : (key === "salesRepName" || key === "routeIdAndName") ? (
                                       <Tooltip title={value} arrow>
                                         <span>{`${capitalizeFirstLetter(truncateString(value,20))} (${multipleFiltersList[key]?.[value] || 0})`}</span>
                                       </Tooltip>
                                     ) : key === "gstNo" ? (
                                       `${value.toLowerCase().includes("non") ? "Non-GST Outlet" : "GST Outlet"} (${multipleFiltersList[key]?.[value] || 0})`
                                     ) : (
                                       <Tooltip title={value} arrow>
                                         <span>{`${capitalizeFirstLetter(value)} (${multipleFiltersList[key]?.[value] || 0})`}</span>
                                       </Tooltip>
                                     )}
                                  </label>
                                ))}
                            </SimpleBar>
                          )
                      )}
                    </div>
                  </div>
                </div>
              </MenuItem>
            </Select>
          </FormControl>
        ) : (
          <FormControl className="manage_order_filter">
            <span
              style={{
                fontSize: "14px",
                color: "#AFAFAF",
              }}
            >
              Filter:
            </span>
            <Select
              labelId="dropdown_label"
              value={statusFilter}
              size="small"
              sx={{ minWidth: "190px", marginLeft: "10px" }}
              onChange={(e) => {
                handleStatusFilterChange(e.target.value);
              }}
              renderValue={(selected) => {
                const item = orderTrackingStagesList.find(
                  (d) => d.id === selected
                );
                return item ? (
                  <div className="dropdown_selected_item">
                    {capitalize(item?.dmsLabel ?? "")}
                  </div>
                ) : null;
              }}
            >
              {orderTrackingStagesList.map((item) => (
                <MenuItem key={item.id} value={item.id}>
                  <div className="dropdown_menu_item">
                    <span>{capitalize(item?.dmsLabel ?? "")}</span>
                  </div>
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
      </div>

      {loader ? (
        <Loader sx={{ position: "absolute", top: "55%" }} />
      ) : (
        <CustomDataGrid
          rows={Array.isArray(rows) ? rows : []}
          columnsMetaData={manageOrderColumnsMetaData()}
          orderStatusConfig={orderTrackingStagesList}
          redirectUrl="/sale/manageOrders/viewOrder/"
          redirectUrlFunction={handleRedirect}
          tableWidth={0.723}
          disabledRowIds={disableRowIds}
          downloadSingleReportConfig={downloadSingleReportConfig}
          handleBulkNav={handleBulkNav}
          isAnyPendingOrder={
            Array.isArray(rows) &&
            rows.some((r) => orderTypeFilterForBulkSync.current.includes(r.status.toUpperCase()))
          }
          orderSourceConfig={orderSourcesRef.current}
          disableOrderEditDesignationBasedChild={disableOrderEditDesignationBased && isUserAllowedToEdit(orderEditAllowedRoles)}
          enableRowClickRedirect={true}
          orderConfirmationEnabled={orderConfirmationEnabled.current}
          onDownloadGeneric={handleCustomDownload}
        />
      )}
    </div>
  );
};

export default ManageSecondaryOrder;
